import React from 'react';
import './BoatSelector.css';

const BoatSelector = ({ boats, selectedBoat, onSelectBoat, onRefresh }) => {
  const handleSelectBoat = (boatId) => {
    onSelectBoat(boatId === selectedBoat ? null : boatId);
  };

  return (
    <div className="boat-selector">
      <div className="boat-selector-header">
        <h2>नाव सूची | Boat List</h2>
        <button 
          className="refresh-button" 
          onClick={onRefresh}
          title="Refresh boat list"
        >
          🔄
        </button>
      </div>
      
      {boats.length === 0 && (
        <div className="no-boats">
          <p>कोई नाव उपलब्ध नहीं है</p>
          <p>No boats available</p>
        </div>
      )}
      
      <ul className="boat-list">
        {boats.map(boat => (
          <li 
            key={boat.boatId} 
            className={selectedBoat === boat.boatId ? 'boat-item selected' : 'boat-item'}
            onClick={() => handleSelectBoat(boat.boatId)}
          >
            <div className="boat-info">
              <h3>{boat.displayName || boat.boatId}</h3>
              {boat.lastLocation && (
                <div className="boat-details">
                  <div>
                    <label>अंतिम अपडेट | Last update:</label>
                    <div>{new Date(boat.lastLocation.timestamp).toLocaleString()}</div>
                  </div>
                  <div className="boat-coords">
                    <label>स्थान | Location:</label>
                    <div>
                      {boat.lastLocation.latitude.toFixed(6)}, {boat.lastLocation.longitude.toFixed(6)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BoatSelector; 